import { useState } from 'react';

const photos = [
  {
    title: 'Custom Tile Shower',
    category: 'Bathroom',
    image: 'https://public.readdy.ai/ai/img_res/78bda31e8deedea8b8551247a7e29d00.jpg'
  },
  {
    title: 'Full Bathroom Renovation',
    category: 'Bathroom',
    image: 'https://readdy.ai/api/search-image?query=complete%20bathroom%20renovation%20modern%20floating%20vanity%20custom%20tile%20floor%20freestanding%20tub%20elegant%20lighting%20fixtures%20high-end%20finishes%20professional%20remodeling&width=800&height=600&seq=fb-gallery-002&orientation=landscape'
  },
  {
    title: 'Basement Finishing',
    category: 'Basement',
    image: 'https://readdy.ai/api/search-image?query=finished%20basement%20transformation%20open%20concept%20living%20space%20modern%20flooring%20recessed%20lighting%20drywall%20complete%20renovation%20professional%20work%20neutral%20tones&width=800&height=600&seq=fb-gallery-003&orientation=landscape'
  },
  {
    title: 'Kitchen Remodel',
    category: 'Kitchen',
    image: 'https://readdy.ai/api/search-image?query=modern%20kitchen%20remodel%20white%20shaker%20cabinets%20quartz%20countertops%20subway%20tile%20backsplash%20stainless%20appliances%20professional%20renovation%20bright%20clean%20design&width=800&height=600&seq=fb-gallery-004&orientation=landscape'
  },
  {
    title: 'Hardwood Flooring',
    category: 'Flooring',
    image: 'https://readdy.ai/api/search-image?query=hardwood%20flooring%20installation%20wide%20plank%20oak%20floors%20professional%20finish%20living%20room%20bright%20natural%20light%20clean%20modern%20interior%20design&width=800&height=600&seq=fb-gallery-005&orientation=landscape'
  },
  {
    title: 'Crown Molding & Trim',
    category: 'Carpentry',
    image: 'https://readdy.ai/api/search-image?query=crown%20molding%20installation%20custom%20trim%20work%20wainscoting%20white%20painted%20walls%20elegant%20carpentry%20detail%20professional%20finish%20bright%20interior&width=800&height=600&seq=fb-gallery-006&orientation=landscape'
  },
  {
    title: 'Master Bath Upgrade',
    category: 'Bathroom',
    image: 'https://readdy.ai/api/search-image?query=master%20bathroom%20upgrade%20luxury%20double%20vanity%20custom%20tile%20walk-in%20shower%20modern%20fixtures%20elegant%20design%20professional%20renovation%20bright%20clean&width=800&height=600&seq=fb-gallery-007&orientation=landscape'
  },
  {
    title: 'Interior Painting',
    category: 'Painting',
    image: 'https://readdy.ai/api/search-image?query=interior%20painting%20professional%20fresh%20coat%20walls%20living%20room%20warm%20neutral%20tones%20clean%20crisp%20lines%20trim%20work%20bright%20modern%20home&width=800&height=600&seq=fb-gallery-008&orientation=landscape'
  },
  {
    title: 'Basement Bar & Lounge',
    category: 'Basement',
    image: 'https://readdy.ai/api/search-image?query=basement%20bar%20lounge%20area%20custom%20built-in%20cabinetry%20modern%20lighting%20tile%20flooring%20entertainment%20space%20professional%20finish%20elegant%20design&width=800&height=600&seq=fb-gallery-009&orientation=landscape'
  },
  {
    title: 'Tile Backsplash',
    category: 'Tile Work',
    image: 'https://readdy.ai/api/search-image?query=kitchen%20tile%20backsplash%20installation%20herringbone%20pattern%20subway%20tiles%20professional%20grouting%20clean%20modern%20kitchen%20bright%20white%20design&width=800&height=600&seq=fb-gallery-010&orientation=landscape'
  },
  {
    title: 'Drywall & Texture',
    category: 'Drywall',
    image: 'https://readdy.ai/api/search-image?query=drywall%20installation%20smooth%20finish%20texture%20professional%20work%20interior%20walls%20ceiling%20clean%20bright%20room%20renovation%20complete%20finish&width=800&height=600&seq=fb-gallery-011&orientation=landscape'
  },
  {
    title: 'Custom Cabinetry',
    category: 'Carpentry',
    image: 'https://readdy.ai/api/search-image?query=custom%20built-in%20cabinetry%20white%20shaker%20style%20living%20room%20built-ins%20shelving%20professional%20carpentry%20elegant%20design%20clean%20bright%20interior&width=800&height=600&seq=fb-gallery-012&orientation=landscape'
  },
];

const categoryColors: Record<string, string> = {
  Bathroom: 'bg-teal-600',
  Basement: 'bg-slate-700',
  Kitchen: 'bg-amber-600',
  Flooring: 'bg-orange-600',
  Carpentry: 'bg-emerald-700',
  Painting: 'bg-rose-600',
  'Tile Work': 'bg-cyan-700',
  Drywall: 'bg-indigo-600',
};

export default function Gallery() {
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

  const handlePrev = (e: React.MouseEvent) => {
    e.stopPropagation();
    setSelectedIndex(prev => (prev !== null ? (prev - 1 + photos.length) % photos.length : 0));
  };

  const handleNext = (e: React.MouseEvent) => {
    e.stopPropagation();
    setSelectedIndex(prev => (prev !== null ? (prev + 1) % photos.length : 0));
  };

  return (
    <section id="gallery" className="py-16 sm:py-20 md:py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">

        {/* Header */}
        <div className="text-center mb-10 sm:mb-12 md:mb-14">
          <span className="text-teal-600 text-sm font-bold tracking-wider uppercase">Photo Gallery</span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 mt-3 mb-4">
            Our Work in Action
          </h2>
          <p className="text-base sm:text-lg text-slate-600 max-w-2xl mx-auto px-4">
            Real projects, real results. Browse photos from our latest jobs across Southeast Michigan — and follow us on Facebook for daily updates.
          </p>
        </div>

        {/* Facebook Banner — Stack on mobile */}
        <div className="flex flex-col sm:flex-row items-center justify-between bg-white border border-slate-200 rounded-2xl px-4 sm:px-6 py-4 mb-8 sm:mb-10 shadow-sm gap-4">
          <div className="flex items-center gap-3 sm:gap-4 w-full sm:w-auto">
            <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-[#1877F2] rounded-xl flex-shrink-0">
              <i className="ri-facebook-fill text-white text-xl sm:text-2xl"></i>
            </div>
            <div className="flex-1 sm:flex-none">
              <p className="font-bold text-slate-900 text-sm sm:text-base">Follow us on Facebook</p>
              <p className="text-slate-500 text-xs sm:text-sm">See our latest projects, tips & customer photos</p>
            </div>
          </div>
          <a
            href="https://www.facebook.com/AmericanDreamRemodelingINC"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#1877F2] hover:bg-[#1565d8] text-white px-5 py-2.5 rounded-full text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-facebook-fill"></i>
            Follow Us
          </a>
        </div>

        {/* Photo Grid — 2 col mobile → 3 col md → 4 col lg */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4">
          {photos.map((photo, index) => (
            <div
              key={index}
              className="group relative rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer aspect-square"
              onClick={() => setSelectedIndex(index)}
            >
              <img
                src={photo.image}
                alt={photo.title}
                className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="absolute bottom-0 left-0 right-0 p-2 sm:p-3 translate-y-2 group-hover:translate-y-0 transition-transform duration-300 opacity-0 group-hover:opacity-100">
                <span className={`inline-block px-2 py-0.5 ${categoryColors[photo.category] ?? 'bg-teal-600'} text-white text-xs font-semibold rounded-full mb-1`}>
                  {photo.category}
                </span>
                <p className="text-white text-xs sm:text-sm font-semibold leading-tight">{photo.title}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA — Stack on mobile */}
        <div className="mt-10 sm:mt-12 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
          <a
            href="https://www.facebook.com/AmericanDreamRemodelingINC"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#1877F2] hover:bg-[#1565d8] text-white px-6 sm:px-7 py-3 sm:py-3.5 rounded-full text-sm sm:text-base font-semibold transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-facebook-fill text-base sm:text-lg"></i>
            See More Photos on Facebook
          </a>
          <a
            href="#estimate"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-teal-600 hover:bg-teal-700 text-white px-6 sm:px-7 py-3 sm:py-3.5 rounded-full text-sm sm:text-base font-semibold transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-file-list-3-line text-base sm:text-lg"></i>
            Get a Free Estimate
          </a>
        </div>
      </div>

      {/* Lightbox — Smaller nav buttons on mobile */}
      {selectedIndex !== null && (
        <div
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-3 sm:p-4"
          onClick={() => setSelectedIndex(null)}
        >
          {/* Close */}
          <button
            className="absolute top-3 right-3 sm:top-4 sm:right-4 w-9 h-9 sm:w-11 sm:h-11 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white text-lg sm:text-xl transition-colors cursor-pointer"
            onClick={() => setSelectedIndex(null)}
          >
            <i className="ri-close-line"></i>
          </button>

          {/* Prev — Closer to edge on mobile */}
          <button
            className="absolute left-2 sm:left-4 top-1/2 -translate-y-1/2 w-9 h-9 sm:w-11 sm:h-11 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white text-lg sm:text-xl transition-colors cursor-pointer"
            onClick={handlePrev}
          >
            <i className="ri-arrow-left-s-line"></i>
          </button>

          {/* Image */}
          <div className="max-w-4xl w-full" onClick={e => e.stopPropagation()}>
            <img
              src={photos[selectedIndex].image}
              alt={photos[selectedIndex].title}
              className="w-full max-h-[70vh] sm:max-h-[75vh] object-contain rounded-lg sm:rounded-xl"
            />
            <div className="mt-3 sm:mt-4 flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-3">
              <span className={`px-2.5 sm:px-3 py-1 ${categoryColors[photos[selectedIndex].category] ?? 'bg-teal-600'} text-white text-xs font-semibold rounded-full`}>
                {photos[selectedIndex].category}
              </span>
              <p className="text-white font-semibold text-base sm:text-lg">{photos[selectedIndex].title}</p>
              <span className="sm:ml-auto text-slate-400 text-xs sm:text-sm">{selectedIndex + 1} / {photos.length}</span>
            </div>
          </div>

          {/* Next — Closer to edge on mobile */}
          <button
            className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 w-9 h-9 sm:w-11 sm:h-11 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white text-lg sm:text-xl transition-colors cursor-pointer"
            onClick={handleNext}
          >
            <i className="ri-arrow-right-s-line"></i>
          </button>
        </div>
      )}
    </section>
  );
}